import st from "@/styles/LoginPage.module.scss";
import clsx from "clsx";
import DashboardClass from "@/utils/dashboard_class.ts";
import LoginLoader from "@/ui/LoginLoader.tsx";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useAtom} from "jotai/index";
import {login_data} from "@/atoms/profile.ts";
import CommonClass from "@/utils/common.ts";
import useAuth from "@/hooks/auth.ts";
import HaveLoggedInterface from "@/types_and_interfaces/have_logged_interface.tsx";
import SessionExpiresWarn from "@/ui/SessionExpiresWarn.tsx";
import {all_inits, pwd_value, refresh_button_show} from "@/atoms/common.ts";
import {GoogleReCaptcha} from "react-google-recaptcha-v3";
import WritePwdFields from "@/ui/WritePwdFields.tsx";
import {getDeviceUUID} from "@/utils/export_functions.ts";
import {requestPermission} from "@/utils/firebase_init.ts";
import i18n from "i18next";

interface Props {
    token_expired?: boolean
    style?: any
}

const LoginBack:React.FC<Props> = ({token_expired, style}) => {
    const [, set_init] = useAtom(all_inits)
    const {t} = useTranslation()
    const navigate = useNavigate();
    const [loginData] = useAtom(login_data)
    const past_user = localStorage.getItem(CommonClass.local_storage_fields.have_logged_data)
    const [loaded, setloaded] = useState<boolean>(false)
    const [reqLoad, setReqLoad] = useState<boolean>(false)
    const [error, setError] = useState(false)
    const uid = getDeviceUUID() || ""
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    const auth = useAuth()
    const [pwd_fields] = useAtom(pwd_value);
    const formRef = useRef<any>(null)
    const past_data:HaveLoggedInterface = past_user !== null ? JSON.parse(past_user) : {}
    const [show_refresh] = useAtom(refresh_button_show)
    const savedPwd = localStorage.getItem("pwdFields");
    const savedUid = localStorage.getItem("uid");

    const handleSetReqLoad = (event:any) => {
        const { value } = event.detail;
        setReqLoad(value);
    };

    const handleSetError = (event:any) => {
        const { value } = event.detail;
        setError(value);
    };

    const loadedHandler = () => {

        if (
            (Object.keys(past_data).length && past_data.hasOwnProperty("value"))
        ){
            setloaded(true)
        }
    }

    const submitForm = async (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()


        const pwd = pwd_fields.join("")

        if(typeof pwd === "string" && uid) {

            if(show_refresh) {
                localStorage.setItem("pwdFields", pwd);
                localStorage.setItem("uid", uid);
                location.reload();
                setReqLoad(true)
                return
            }

            let is_login_page = false;

            Object.entries(DashboardClass.login_routes).forEach((obj) => {
                if (typeof obj[1] === "string" && window.location.href.includes(obj[1])) {
                    is_login_page = true;
                    return;
                }
            });

            if(is_login_page) {
                localStorage.setItem(CommonClass.local_storage_fields.login_kyc_checking_active, "true")
            }

            if(!token_expired) localStorage.setItem(CommonClass.local_storage_fields.login_kyc_checking_active, "true")
            await auth.auth(pwd)
        }
    }

    useEffect(() => {
        if(pwd_fields.length === 4) {
            let completed = true

            pwd_fields.map((x) => {
                if(x === "" || x === " ") {
                    completed = false
                }

            })

            if(completed && formRef.current) {
                formRef.current.requestSubmit()
                requestPermission(i18n.language)
            }
        }
    }, [pwd_fields]);

    useEffect(() => {
        loadedHandler()
    }, [loginData]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if(debug === "true") console.info("setTimeout get_transaction_id_handle")

            if(past_user === null) {
                navigate(DashboardClass.login_routes.LoginStep1)
            }
        }, 2000)


        window.addEventListener(CommonClass.CustomEvents.set_req_load, handleSetReqLoad)
        window.addEventListener(CommonClass.CustomEvents.set_err, handleSetError)

        return () => {
            clearTimeout(timeout)
            window.removeEventListener(CommonClass.CustomEvents.set_req_load, handleSetReqLoad)
            window.removeEventListener(CommonClass.CustomEvents.set_err, handleSetError)
        }
    }, []);

    return loaded && (
        <div className={clsx(st.log_vars, st.log_back, style?.log_back)}>

            {(savedPwd && savedUid) ? (
                <GoogleReCaptcha onVerify={() => {
                    auth.auth(savedPwd);
                    localStorage.removeItem("pwdFields");
                    localStorage.removeItem("uid");
                }

                } />
            ) : null}


            <form ref={formRef} className={st.other_steps} onSubmit={submitForm}>

                <div className={clsx(st.top, style?.top)}>
                    {token_expired ? (

                        <div className={clsx(st.heading, style?.heading)}>
                            <SessionExpiresWarn />

                            <p className={clsx(st.inf_text, style?.description)}>
                                {t("session_expired1")} {t("use_pin_for")} <span className={style?.green}>{past_data.value}</span>
                            </p>

                            <div className={clsx(st.info, style?.info)}>

                                <p className={clsx(st.inf_text, style?.inf_text)}>

                                </p>

                            </div>

                        </div>

                    ) : (

                        <div className={st.heading}>
                            {t("welcome_back")}

                            <div className={st.info}>
                                <span className={st.inf_text}>
                                    {t("use_pin_for")} {past_data.value}
                                </span>
                            </div>

                        </div>
                    )}

                    <div className={clsx(st.form_core, style?.form_core)}>

                        <WritePwdFields className={style?.pwd} error={error}/>

                    </div>
                </div>


                <div className={clsx(st.bottom, style?.bottom)}>

                    {/*<Button type={"submit"} animated className={clsx(st.auth_btn, style?.auth_btn)}>*/}
                    {/*    <span>*/}
                    {/*        {t("auth")}*/}
                    {/*    </span>*/}
                    {/*</Button>*/}

                    {token_expired && (
                        <button
                            onClick={() => {
                                set_init(false)
                                let timeout = setTimeout(() => {
                                    auth.logOut()
                                    clearTimeout(timeout)
                                }, 500)
                            }}
                            type={"button"}
                            className={clsx(st.logout, style?.logout)}
                        >
                            <span>
                                {t("exit")}
                            </span>
                        </button>
                    )}

                </div>


                {reqLoad &&
                    <LoginLoader transparent/>
                }

            </form>
        </div>
    )
}

export default LoginBack